import pluralize from 'pluralize';

export const getPlural = (value: string, count: number) => {
  return pluralize(value, count);
};
